import moment from 'moment';
export default (v) => {
    return  moment(v).format('DD/MM/YYYY HH:mm:ss');
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/fecha-db.js